(() => {
  if (window.maiiBisLocalizationReady) return;
  window.maiiBisLocalizationReady = true;

  const pathLocale = window.location.pathname.split('/')[1] === 'fr' ? 'fr' : 'en';
  const locale = String(window.Shopify?.locale || document.documentElement.lang || pathLocale)
    .toLowerCase()
    .split('-')[0];
  const isFrench = locale === 'fr';
  const copy = isFrench
    ? {
        title: 'M’avertir',
        trigger: 'M’avertir',
        email: 'Adresse e-mail',
        newsletter: 'Informez-moi des promotions et réductions. Inscrivez-moi à l’infolettre.',
        disclaimer: 'Nous vous avertirons uniquement lorsque le produit sera de nouveau en stock.',
        close: 'Fermer',
        question: (productTitle) =>
          `Souhaitez-vous être averti(e) lorsque ${productTitle} sera de nouveau en stock ?`,
      }
    : {
        title: 'Notify me',
        trigger: 'Notify me!',
        email: 'Email',
        newsletter: 'Email me the latest promotions and discounts. Subscribe me to the newsletter.',
        disclaimer: 'We will only notify you when this product is back in stock.',
        close: 'Close',
        question: (productTitle) => `Would you like us to notify you when ${productTitle} is back in stock?`,
      };

  const setText = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element && element.textContent !== value) element.textContent = value;
  };

  const localizeBackInStockDialog = () => {
    document
      .querySelectorAll('[data-essential-preorder-element="back-in-stock-button"]')
      .forEach((button) => {
        const label = button.querySelector('.essential-preorder-back-in-stock-initial-add-to-cart-text');
        if (label && label.textContent.trim() !== copy.trigger) label.textContent = copy.trigger;
        if (button.getAttribute('aria-label') !== copy.trigger) {
          button.setAttribute('aria-label', copy.trigger);
        }
      });

    const dialog = document.querySelector(
      '[data-essential-preorder-element="back-in-stock-pop-up-container"]'
    );
    if (!dialog) return;

    const productTitle = document.querySelector('.product__title h1')?.textContent?.trim() || '';
    setText(dialog, '[data-essential-preorder-element="back-in-stock-pop-up-title"]', copy.title);
    setText(
      dialog,
      '[data-essential-preorder-element="back-in-stock-pop-up-description"]',
      copy.question(productTitle)
    );
    setText(
      dialog,
      'label[for="essential-preorder-bis-email"]',
      copy.email
    );
    setText(
      dialog,
      '[data-essential-preorder-element="back-in-stock-pop-up-newsletter-label"]',
      copy.newsletter
    );
    setText(
      dialog,
      '[data-essential-preorder-element="back-in-stock-pop-up-button-text"]',
      copy.title
    );
    setText(
      dialog,
      '[data-essential-preorder-element="back-in-stock-pop-up-disclaimer"]',
      copy.disclaimer
    );

    const email = dialog.querySelector('#essential-preorder-bis-email');
    if (email && email.placeholder !== copy.email) email.placeholder = copy.email;

    const close = dialog.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-close"]');
    if (close && close.getAttribute('aria-label') !== copy.close) {
      close.setAttribute('aria-label', copy.close);
    }
  };

  const observer = new MutationObserver(localizeBackInStockDialog);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', localizeBackInStockDialog);
  localizeBackInStockDialog();
})();
